import {React, useEffect, useState} from "react";

import repository from '@/modules/admin/pages/vehicle/repository';

export function ComboVehicleProfile({handle, name, value}) {
    
  const [list, setList] = useState([]);

  useEffect(() => {
    
    repository.getComboProfile((response) => {
      setList(response.data);
    });

  }, []);

  const html = () => {

    var content;

    if(list.length > 0){

      content = list.map(item => {
        return <option key={item.id} value={item.id}>{item.clientTitle+" - "+item.title}</option>
      });
    }

    return content;
  }

  return (
    <>
      <select onChange={handle} name={name} value={value}>
        <option value="0">-Selecione-</option>
        {html()}
      </select>
    </>
  )  
}

export default ComboVehicleProfile;